.stack {
  position: fixed; right: 24px; bottom: 24px;
  display: flex; flex-direction: column; gap: 10px;
  z-index: 40;
  max-width: 380px;
}
.banner {
  position: relative;
  background: var(--bg-elevated);
  border: 1px solid var(--accent);
  border-radius: var(--r-lg);
  padding: 14px 16px 12px;
  box-shadow: var(--shadow-lg);
  animation: slideUp var(--dur-mid) var(--ease);
}
.alert { border-color: var(--warn); }
@keyframes slideUp { from { transform: translateY(12px); opacity: 0; } to { transform: none; opacity: 1; } }

.close {
  position: absolute; top: 8px; right: 8px;
  width: 24px; height: 24px;
  display: flex; align-items: center; justify-content: center;
  color: var(--text-muted); border-radius: var(--r-xs);
}
.close:hover { background: var(--bg-elevated-2); color: var(--text-primary); }

.head {
  display: flex; align-items: center; gap: 6px;
  font-size: var(--fs-xs);
  color: var(--text-secondary);
  text-transform: uppercase; letter-spacing: 0.06em;
}
.title { font-size: var(--fs-lg); font-weight: 600; margin: 4px 0 2px; }
.meta { font-size: var(--fs-sm); color: var(--text-secondary); }
.countdown { font-size: var(--fs-sm); color: var(--accent-hover); margin-top: 8px; }
.countdown strong { font-variant-numeric: tabular-nums; }
.actions { display: flex; gap: 8px; margin-top: 12px; }
.actions .btn { flex: 1; justify-content: center; }
